import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './End.st.css.js';
class End extends React.PureComponent {
    render() {
        const { children } = this.props;
        return React.createElement("div", { className: classes.end }, children);
    }
}
End.propTypes = {
    children: PropTypes.node,
};
export default End;
//# sourceMappingURL=End.js.map